import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid, Typography } from "@mui/material";
import moment from 'moment';
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../components/Form/CustomSelect2";
import Helpers from "../../../helpers/helpers";
import { deleteUser, exportUserExcel, getUser, resetUserAttachmentState, resetUserState } from "../../../store/actions";
import "../setting.css";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../../components/Common/DeleteModal.js";


const UserSetting = ({ userListing, roleList, delUserArry, exportExcel, userPermission }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [status, setStatus] = useState("");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState("id");
    const [selectedRow, setSelectedRow] = useState();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission]);

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    const header = [
        {
            Header: "Name ",
            columnID: "id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div style={{ paddingRight: "5px" }}>{cellProps.name}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusByIDLabel label={cellProps?.status} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Email Address",
            accessor: "email",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Role",
            columnID: "role_id",
            accessor: (cellProps) => {
                return (<React.Fragment>
                    {Helpers.getValueFromData(roleList, parseInt(cellProps?.role_id), "name")}
                </React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Job Title",
            columnID: "job_title",
            accessor: (cellProps) => {
                return (<React.Fragment>
                    {cellProps?.job_title || "-"}
                </React.Fragment>)
            }, disableFilters: true,
            filterable: false,
        },
        {
            Header: "Creation Date",
            columnID: "created_at",
            accessor: (cellProps) => {
                return (<React.Fragment>
                    <Typography style={{ fontFamily: 'Manrope', fontSize: 14 }}>{moment(cellProps.created_at).format("DD MMM YYYY")}</Typography>
                    <Typography style={{ fontFamily: 'Manrope', fontSize: 14, color: "#A0A0A0", }}>{moment(cellProps.created_at).format("hh:mm A")}</Typography>
                </React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <Link to={`/edit-user/` + (cellProps.id)}>
                            <CustomIconButton
                                iconName={'ri-pencil-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                        <RenderPopOverButton
                            items={[{ iconName: 'ri-delete-bin-line', label: 'Delete', color: '#ED1A3D', permission: deletable, onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) } }]}
                        />
                    </React.Fragment>
                )
            },
            position: 'sticky',
            disableFilters: true,
            filterable: false,
            minWidth: 120
        }
    ]

    useEffect(() => {
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, page, length, sort, sort_by]);

    const initData = () => {
        dispatch(getUser({ length, page, name: searchRef.current, status: status === 'all' ? '' : status, sort, sort_by }));
    }

    const resetFilter = () => {
        setStatus(status === '' ? 'all' : '');
        setSearch("");
    }

    useEffect(() => {
        if (delUserArry?.code === "success") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({ open: true, msg: "User deleted successfully", type: "success" });
            dispatch(resetUserState());
            initData();
        }
    }, [delUserArry])

    useEffect(() => {
        if (exportExcel?.code === "success") {
            setIsLoading(false)
            Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'user_listing');
            dispatch(resetUserAttachmentState());
        }

    }, [exportExcel]);

    const handleExport = () => {
        let filter = {
            status: status === 'all' ? '' : status,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        dispatch(exportUserExcel({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
        setIsLoading(true)
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const handleDelete = () => {
        if (selectedRow?.id) {
            dispatch(deleteUser({ id: selectedRow.id }));
            setIsLoading(true);
        }
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={10} md={10} lg={10} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3} md={3} sm={4} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={3} md={4} sm={4} xs={12}>
                        <CustomSelect2 values={status || 'all'} onChange={(e) => { setPage("1"); setStatus(e) }} data={Helpers.status} />
                    </Grid>
                    <Grid item lg={6} md={3} sm={4} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item xs={12} sm={2} md={2} lg={2} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', sm: 'end', xs: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !userListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        title='Users'
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: "Users", link: "#" },
                        ]}
                    >
                        {creatable && <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add User</>}
                            press={() => navigate("/add-user")}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />}
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={userListing && userListing?.data}
                        pageSize={length}
                        totalPage={userListing?.lastPage}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={userListing && userListing?.last_page}
                    />
                </Container>
                <DeleteModal
                    open={deleteOpen}
                    close={() => setDeleteOpen(false)}
                    submit={() => handleDelete()}
                    module={'user'}
                />
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ User, General, Login }) {
    return {
        userListing: User.user,
        delUserArry: User.delUser,
        exportExcel: User.exportExcel,
        roleList: General.roleList,
        userPermission: Login.permissionArry,
    };
}

export default connect(mapStateToProps)(UserSetting);
